import { UserRole } from 'shared/types/userRole';
import { PermissionManagerFactory } from '../permissionManagerFactory';
import { PermissionConfig } from '../types';

export const CREATE_COMPANY_PERMISSIONS: PermissionConfig = {
  [UserRole.superAdmin]: true,
  [UserRole.organizationAdmin]: true,
  [UserRole.projectAdmin]: true,
  [UserRole.manager]: true,
  [UserRole.viewer]: false,
  [UserRole.standard]: false,
  [UserRole.visible_no_access]: false,
};

export const EDIT_COMPANY_PERMISSIONS: PermissionConfig =
  CREATE_COMPANY_PERMISSIONS;

export const CompanyPermissionManager = PermissionManagerFactory.create<
  void,
  void,
  void
>({
  permissionConfigForCreate: CREATE_COMPANY_PERMISSIONS,
  permissionConfigForEdit: EDIT_COMPANY_PERMISSIONS,
  permissionConfigForDelete: null,
});
